import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'BLOG/SERVICES';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetBlogServices(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const response = yield client.post('/merchant/service/getBlogServices', {
      data: { site: siteId },
    });

    yield put(actions.loadSuccess(response.result.services));
    resolve && resolve(response.result.services);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
